import { render } from "./SendFilesNimp.vue?vue&type=template&id=3c3379ef&scoped=true"
import script from "./SendFilesNimp.vue?vue&type=script&lang=js"
export * from "./SendFilesNimp.vue?vue&type=script&lang=js"

import "./SendFilesNimp.vue?vue&type=style&index=0&id=3c3379ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3379ef"]])

export default __exports__